<app-splash></app-splash>
<app-motto></app-motto>
<app-team></app-team>
<app-mission></app-mission>
<!--<app-gallery></app-gallery>-->
<app-impressionen></app-impressionen>
<app-map></app-map>